import showdown from 'showdown';
import Vue from 'vue';
import axios from "axios";


//defines Strapi Store for Data
//use for fetching json data and as Url for icons


export const configData = Vue.observable({
	baseUrl: "",
})

const getRuntimeConfig = async () => {
	const runtimeConfig = await axios.get('runtimeconfig.json');
	return await runtimeConfig;
}


export default class JsonProvider {

	async fetchJsonObject(url, sorted = false) {
		if (!configData.baseUrl) {
		var jsonObject = await getRuntimeConfig();
		configData.baseUrl = jsonObject;
		}

		var result = await axios.get(configData.baseUrl.data.baseUrl + url) 
				.then(response => {
					return response.data;
				})
			.catch(e => {
				//eslint-disable-next-line no-console
				console.log(e);
			})
		if(sorted) {
			result.sort(function(a ,b) {
			return a.idNo - b.idNo;
			});
		}
		return result;

	}

}


export class MarkdownProvider {

	convertMarkdown(text) {
		var converter = new showdown.Converter({simpleLineBreaks: true, ghCompatibleHeaderId: false});
		return converter.makeHtml(text);
	}
}
